import { apiClient } from './client';
import type { ApiResponse } from '@/types/api.types';
import type { DashboardStats } from '@/types/dashboard.types';
import type {
  ExecutiveSummary,
  DashboardAlert,
  WorkflowSummary,
  ArApSummary,
  RecentActivity,
  WelcomeBriefingData,
} from '@/types/dashboardEnterprise.types';

export const dashboardApi = {
  /** GET /api/v1/reports/dashboard — GL KPIs and recent journal entries */
  getStats: () =>
    apiClient.get<ApiResponse<DashboardStats>>('/reports/dashboard'),

  /** GET /api/v1/dashboard/executive-summary — top-level KPI tiles */
  getExecutiveSummary: () =>
    apiClient.get<ApiResponse<ExecutiveSummary>>('/dashboard/executive-summary'),

  /** GET /api/v1/dashboard/alerts — prioritised operational alerts */
  getAlerts: () =>
    apiClient.get<ApiResponse<DashboardAlert[]>>('/dashboard/alerts'),

  /** GET /api/v1/dashboard/workflow-summary — per-module workflow queue depths */
  getWorkflowSummary: () =>
    apiClient.get<ApiResponse<WorkflowSummary>>('/dashboard/workflow-summary'),

  /** GET /api/v1/dashboard/ar-ap-summary — AR/AP aging buckets + top overdue */
  getArApSummary: () =>
    apiClient.get<ApiResponse<ArApSummary>>('/dashboard/ar-ap-summary'),

  /** GET /api/v1/dashboard/recent-activity — last 7 days of GL/AR/AP activity */
  getRecentActivity: (limit = 20) =>
    apiClient.get<ApiResponse<RecentActivity>>(`/dashboard/recent-activity?limit=${limit}`),

  /** GET /api/v1/dashboard/welcome-briefing — post-login briefing aggregate */
  getWelcomeBriefing: () =>
    apiClient.get<ApiResponse<WelcomeBriefingData>>('/dashboard/welcome-briefing'),
};
